export default __webpack_public_path__ + "static/media/deleteHover.0598c597.svg";